import Capture from './Capture';

export default Capture;
